import React from "react";

import { connect } from "react-redux";

import Select from "./index";

function Currency({ dispatch, config, ...props }) {
  const items = Object.values(config).map((entity) => entity.currency);

  return <Select name="currency" items={items} {...props} />;
}

const mapStateToProps = (state) => ({
  config: state.prp.config.length ? state.prp.config : state.prp.me.config,
});

export default connect(mapStateToProps)(Currency);
